import React from 'react';

import {AppButton} from '../../../../components/Button';
import appConfig from '../../../../config/appConfig';
import * as localizationKeys from '../../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../../services/localization/localizationService';

const PreferenceCenterLink = () => {
    const privacyNoticeUrl = appConfig.getPrivacyNoticeUrlFormatted();
    const localizedStrings = getLocalizedStrings();
    const buttonText = localizedStrings[localizationKeys.PRIVACY_NOTICE_LINK_TITLE_TEXT];

    if (!buttonText) return null;

    return privacyNoticeUrl ? (
        <AppButton
            tertiary
            to={privacyNoticeUrl}
            // 'overflow-visible' is needed to override 'overflow: hidden' on ch market
            className='overflow-visible font-bold'
            isExternalLink
            isTargetBlank
        >
            {buttonText}
        </AppButton>
    ) : (
        <span className='font-bold underline'>{buttonText}</span>
    );
};

export default PreferenceCenterLink;
